const scriptLoader = {
    loadedScripts: [],
    loadedStyles: [],
    loadScript(src) {
        if (this.loadedScripts.indexOf(src) !== -1) {
            return
        }

        this.loadedScripts.push(src)

        if (document) {
            const script = document.createElement('script')
            script.setAttribute('src', src)
            document.head.appendChild(script)
        }
    },
    loadStyle(src) {
        if (this.loadedStyles.indexOf(src) !== -1) {
            return
        }

        this.loadedStyles.push(src)

        if (document) {
            const style = document.createElement('link')
            style.setAttribute('type', 'text/css')
            style.setAttribute('rel', 'stylesheet')
            style.setAttribute('href', src)
            document.head.appendChild(style)
        }
    }
}

export default {
    install: function (Vue) {
        Vue.prototype.$scriptLoader = scriptLoader;
    }
}
